import { updateObject } from "utils";

function reducer(state, action) {
  switch (action.type) {
    case "SWITCH_TAB":
      return updateObject(state, {
        currentTab: action.tab
      });
    case "OPEN_POPUP":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          show: true,
          alertName: action.alertName,
          params: action.params
        })
      });
    case "CLOSE_POPUP":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          show: false
        })
      });
    case "SHOW_NOTIFY":
      return updateObject(state, {
        notify: updateObject(state.notify, {
          show: true,
          params: action.params
        })
      });
    case "CLOSE_NOTIFY":
      return updateObject(state, {
        notify: updateObject(state.notify, {
          show: false,
          params: null
        })
      });
    case "SHOW_VALIDATION":
      return updateObject(state, {
        validation: updateObject(state.validation, {
          ...action.obj
        })
      });
    case "CLOSE_VALIDATION":
      return updateObject(state, {
        validation: updateObject(state.validation, {
          status: true,
          msg: "",
          params: {}
        })
      });
    case "SHOW_REFRESH":
      return updateObject(state, {
        refresh: updateObject(state.refresh, {
          show: true,
          fetch: action.fetch
        })
      });
    case "CLOSE_REFRESH":
      return updateObject(state, {
        refresh: updateObject(state.refresh, {
          show: false,
          fetch: null
        })
      });
    case "DISABLE_CLOSE":
      return updateObject(state, {
        disableClose: updateObject(state.disableClose, {
          close: action.close,
          params: action.params
        })
      });
    case "DISABLE_POPUP_CONFIRM":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          params: updateObject(state.popup.params, {
            disable: action.disable
          })
        })
      });
    case "DISABLE_LEFT_FOOTER":
      return updateObject(state, {
        popup: updateObject(state.popup, {
          params: updateObject(state.popup.params, {
            disableLeftFooter: action.disable
          })
        })
      });
    default:
      throw new Error();
  }
}

export default reducer;
